import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import api from "../../lib/api";

export default function Rankings() {
    const [polls, setPolls] = useState([]);
    const [hs, setHs] = useState([]);
    useEffect(() => {
        api.get("/football/college/rankings").then(r => setPolls(r.data.polls || [])).catch(() => {});
        api.get("/football/hs/rankings").then(r => setHs(r.data.slice(0, 10))).catch(() => {});
    }, []);

    return (
        <PageLayout>
            <section className="pt-28 pb-10 border-b border-white/10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Digital Beast · Rankings</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="rankings-heading">
                        THE <span className="text-[#d4af37]">RANKINGS.</span>
                    </h1>
                </div>
            </section>
            <TrendingBar />

            <section className="py-10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-6">
                    <div>
                        <div className="section-label mb-4">{polls[0]?.name || "AP Top 25"}</div>
                        <div className="surface p-5 space-y-2">
                            {(polls[0]?.ranks || []).slice(0, 25).map(r => (
                                <div key={r.current} className="flex items-center gap-3 border-b border-white/5 py-1.5">
                                    <div className="font-display text-xl text-[#d4af37] w-8">{r.current}</div>
                                    {r.logo && <img src={r.logo} alt="" className="w-6 h-6" />}
                                    <div className="text-white text-sm flex-1 truncate">{r.team}</div>
                                    <div className="text-white/40 text-xs font-mono">{r.record}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <div className="section-label mb-4">High School Top 10</div>
                        <div className="surface p-5 space-y-2">
                            {hs.map(t => (
                                <Link key={t.id} to={`/football/high-school/${t.slug}`} className="flex items-center gap-3 border-b border-white/5 py-1.5 hover:text-[#d4af37]">
                                    <div className="font-display text-xl text-[#d4af37] w-8">{t.rank}</div>
                                    <div className="flex-1 text-white text-sm">{t.school}</div>
                                    <div className="text-white/40 text-xs">{t.state}</div>
                                </Link>
                            ))}
                            <Link to="/football/high-school" className="btn-ghost text-xs mt-3 inline-block">Full Top 50 →</Link>
                        </div>
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
